// extracted by mini-css-extract-plugin
module.exports = {"divider":"Loader_divider__2wZeM","Loader":"Loader_Loader__3w7V8","loader":"Loader_loader__2hZcM"};